import { Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useThemeStore } from './stores/themeStore';
import { LoginPage } from './pages/LoginPage';
import { Dashboard } from './pages/Dashboard';
import { ProductsPage } from './pages/ProductsPage';
import { LicensesPage } from './pages/LicensesPage';
import { ServersPage } from './pages/ServersPage';
import { CustomersPage } from './pages/CustomersPage';
import { CustomerDetailPage } from './pages/CustomerDetailPage';
import { LogsPage } from './pages/LogsPage';
import { SettingsPage } from './pages/SettingsPage';
import { ApiDocsPage } from './pages/ApiDocsPage';
import { Layout } from './components/Layout';
import { AuthGuard } from './components/AuthGuard';

function App() {
    const { darkMode } = useThemeStore();

    const theme = createTheme({
        palette: {
            mode: darkMode ? 'dark' : 'light',
            primary: {
                main: '#f97316',
            },
            secondary: {
                main: '#64748b',
            },
        },
        typography: {
            fontFamily: 'Inter, system-ui, sans-serif',
        },
    });

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route element={<AuthGuard />}>
                    <Route path="/" element={<Layout />}>
                        <Route index element={<Navigate to="/dashboard" replace />} />
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="products" element={<ProductsPage />} />
                        <Route path="licenses" element={<LicensesPage />} />
                        <Route path="servers" element={<ServersPage />} />
                        <Route path="customers" element={<CustomersPage />} />
                        <Route path="customers/:customerId" element={<CustomerDetailPage />} />
                        <Route path="logs" element={<LogsPage />} />
                        <Route path="settings" element={<SettingsPage />} />
                        <Route path="docs" element={<ApiDocsPage />} />
                    </Route>
                </Route>
            </Routes>
        </ThemeProvider>
    );
}

export default App;